import type { FC } from "react";

import PortalViewPreview from "../../AffiliateProfile/AffiliateInfo/PortalViewPreview";
import PortalVisibilityToggles from "../../AffiliateProfile/AffiliateInfo/PortalVisibilityToggles";
import { AppStrings } from "../../../../utils/constants/AppStrings";

import { type ShareableColumnId } from "./affiliatePamAccountData";

import styles from "./AffiliatePamView.module.css";

export type AffiliatePamViewProps = {
  selectedColumns: ShareableColumnId[];
  onToggleColumn: (id: ShareableColumnId) => void;
  // Lets consumers keep their pre-existing testid selectors.
  idPrefix: string;
};

/**
 * Wizard step body: the same portal preview + toggle panel as the Edit
 * Portal View modal, minus the save plumbing. No affiliate exists yet,
 * so every preview tab renders its empty state.
 */
const AffiliatePamView: FC<AffiliatePamViewProps> = ({
  selectedColumns,
  onToggleColumn,
  idPrefix,
}) => (
  <div className={styles.body}>
    <PortalViewPreview
      selectedColumns={selectedColumns}
      idPrefix={idPrefix}
      ariaLabel={AppStrings.NEW_AFFILIATE_PAM_ACCOUNT_TITLE}
    />
    <PortalVisibilityToggles
      value={selectedColumns}
      onToggle={onToggleColumn}
      idPrefix={idPrefix}
    />
  </div>
);

export default AffiliatePamView;
